import HttpService from './HttpService';
import { getUrlExpeditionApi, showMessageToastCustom, translate } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as actionPackList from '../actions/packListAction';
import { parseParams } from '../utils/util';


const httpService = new HttpService(getUrlExpeditionApi(window));
export default class PackListService {

    static get(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/packlist';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data;
                        dispatch(actionPackList.setOrders(dados.data));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static createPackList(filter, callback) {
        const url = '/api/packlist';

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('sucess', 'general'), "", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static approve(item, callback) {
        const url = '/api/packlist/approve';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, item).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('sucess', 'general'), "", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static reprove(item, callback) {
        const url = '/api/packlist/reprove';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, item).then((response) => {
                    if (response.status === 200) {
                        showMessageToastCustom(translate('sucess', 'general'), "", 8000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static report(filter, callback) {
        const url = '/api/packlist/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static reportPdf(filter, callback) {
        const url = '/api/packlist/report/pdf';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data.data) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

}